import Body from "../layouts/Body";
import Page from "../layouts/Page";
import LoadingContainer from "./LoadingContainer";

import styles from "../../styles/LoadingPage.module.less";

const LoadingPage = () => {
  return (
    <Page>
      <Body className={styles.body}>
        <LoadingContainer />
      </Body>
    </Page>
  );
};

export default LoadingPage;
